module.exports = __webpack_public_path__ + "img/0S6A9628.6ad4e1e6.jpg";